import React from "react";

export const SuccessAlert = (props) => {
  return (
    <div className="fgaAlert successAlert">
      <p>{props.content}</p>
    </div>
  );
};
